import clsx from "clsx";
import { BottomCardRoot } from "./BottomCard.styles";

export interface BottomCardProps {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

function BottomCard({ className, children, ...rest }: BottomCardProps) {
    return (
        <BottomCardRoot className={clsx("bottom-card", className)} {...rest}>
            {children}
        </BottomCardRoot>
    );
}

export default BottomCard;
